import React from "react";
import {
  View,
  Text,
  Modal,
  StyleSheet,
  TouchableOpacity,
  TouchableNativeFeedback,
  ScrollView,
  ActivityIndicator,
  Dimensions,
  PixelRatio,
  Image,
} from "react-native";
import CloseIcon from "@assets/svg/CloseIcon";
import { useSafeAreaInsets } from "react-native-safe-area-context";
import metrics from "@constants/metrics";
import colors from "@constants/color";

export const { width, height } = Dimensions.get("window");
const scale = width / 360;

export const normalize = (size) => {
  const newSize = size * scale;
  return Math.round(PixelRatio.roundToNearestPixel(newSize));
};

const OssModal = (props) => {
  const insets = useSafeAreaInsets();
  const { visible, handleClose, data, loadingCartConfirm, handlePlaceOrder } =
    props;

  const products = data.find((ossItem) => ossItem.type === "oosProducts");
  const bottomStrip = data.find((ossItem) => ossItem.type === "redBottomStrip");

  return (
    <Modal
      statusBarTranslucent
      navigationBarTranslucent
      transparent
      animationType="slide"
      hardwareAccelerated
      onRequestClose={handleClose}
      visible={visible}
    >
      <View style={styles.container}>
        <View style={{ height: "30%" }} />
        <View style={styles.content}>
          <View style={styles.headerContainer}>
            <View style={{ flexDirection: "row" }}>
              <Image
                source={{ uri: products.icon }}
                style={{
                  height: 16,
                  width: 16,
                  marginRight: 5,
                }}
              />
              <Text bold fontType="head1">
                {products.title}
              </Text>
            </View>
            <TouchableOpacity onPress={handleClose}>
              <CloseIcon />
            </TouchableOpacity>
          </View>

          <ScrollView
            contentContainerStyle={{ paddingHorizontal: metrics.baseGutter }}
          >
            {products.items.map((product, index) => (
              <View
                style={{
                  flexDirection: "row",
                  paddingVertical: metrics.baseGutter,
                  borderBottomWidth: 1,
                  marginBottom: 5,
                  borderBottomColor: "rgba(0,0,0,0.1)",
                }}
              >
                <View style={{ marginRight: 10 }}>
                  <Image
                    resizeMode={"contain"}
                    style={{
                      width: normalize(70),
                      height: normalize(70),
                    }}
                    source={
                      product.product_image
                        ? {
                            uri: product.product_image,
                          }
                        : require("@assets/images/defaultImage.webp")
                    }
                  />
                </View>
                <View style={{ width: "100%" }}>
                  <View style={{ width: "75%" }}>
                    <Text
                      fontType="head1"
                      style={styles.productTitle}
                      numberOfLines={1}
                      ellipsizeMode="tail"
                    >
                      {product.short_name_hi}
                    </Text>
                  </View>

                  <View
                    style={{
                      flexDirection: "row",
                      alignItems: "center",
                      padding: 5,
                      width: "75%",
                      paddingHorizontal: 10,
                      borderWidth: 1,
                      borderRadius: 5,
                      borderColor: product.custom_text_border,
                      backgroundColor: product.custom_text_background,
                    }}
                  >
                    <Image
                      source={{ uri: product.custom_symbol }}
                      style={{
                        height: 16,
                        width: 16,
                      }}
                    />
                    <Text
                      bold
                      style={styles.offertext}
                      numberOfLines={1}
                      ellipsizeMode="tail"
                    >
                      {product.custom_text}
                    </Text>
                  </View>
                </View>
              </View>
            ))}
            <View />
          </ScrollView>

          {bottomStrip && (
            <View
              style={[
                styles.bottomStrip,
                { paddingBottom: metrics.baseGutter + insets.bottom },
              ]}
            >
              {Boolean(bottomStrip.title) && (
                <View style={{ marginBottom: 5 }}>
                  <Text style={styles.bottomStripText} bold fontType="head1">
                    {bottomStrip.title}
                  </Text>
                </View>
              )}
              <View style={styles.bottomStripContainer}>
                <View>
                  <Text style={styles.bottomStripText} fontType="content2">
                    {bottomStrip.subTitle}
                  </Text>
                  <View style={{ flexDirection: "row" }}>
                    <Text
                      style={[
                        styles.bottomStripText,
                        styles.bottomStripPrice,
                        { marginRight: 10 },
                      ]}
                      fontType="head2"
                    >
                      {bottomStrip.amount}
                    </Text>
                    <Text
                      style={[
                        styles.bottomStripText,
                        { textDecorationLine: "line-through" },
                      ]}
                      fontType="head2"
                    >
                      {bottomStrip.amountStrikeThrough}
                    </Text>
                  </View>
                </View>
                <View>
                  <TouchableOpacity
                    style={styles.bottomStripButton}
                    onPress={handlePlaceOrder}
                  >
                    {!loadingCartConfirm && (
                      <Text fontType="head1" bold>
                        {bottomStrip.ctaText}
                      </Text>
                    )}
                    {loadingCartConfirm && (
                      <ActivityIndicator size="small" color={colors.primary} />
                    )}
                  </TouchableOpacity>
                </View>
              </View>
            </View>
          )}
        </View>
      </View>
    </Modal>
  );
};

const styles = StyleSheet.create({
  container: {
    backgroundColor: "rgba(0,0,0,0.36)",
    flex: 1,
  },
  content: {
    height: "70%",
    backgroundColor: "white",
    borderTopLeftRadius: 20,
    borderTopRightRadius: 20,
  },
  headerContainer: {
    padding: metrics.baseGutter,
    flexDirection: "row",
    justifyContent: "space-between",
  },
  bottomStripContainer: {
    flexDirection: "row",
    justifyContent: "space-between",
  },
  bottomStrip: {
    backgroundColor: "#C90022",
    borderTopLeftRadius: 10,
    borderTopRightRadius: 10,
    padding: metrics.baseGutter,
  },
  bottomStripText: {
    color: "#fff",
  },
  bottomStripPrice: {
    fontWeight: "bold",
  },
  bottomStripButton: {
    paddingVertical: 10,
    paddingHorizontal: 15,
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "white",
    borderRadius: 10,
  },
  productTitle: {
    // flex: 1,
    flexWrap: "wrap",
    lineHeight: 24,
    marginBottom: 5,
  },
  offertext: {
    color: "rgba(0, 0, 0, 0.56)",
    fontSize: 13,
    marginLeft: 6,
  },
});

export default OssModal;
